import { render, staticRenderFns } from "./driverManagementLJ.vue?vue&type=template&id=70540a2a&scoped=true&"
import script from "./driverManagementLJ.vue?vue&type=script&lang=js&"
export * from "./driverManagementLJ.vue?vue&type=script&lang=js&"
import style0 from "./driverManagementLJ.vue?vue&type=style&index=0&id=70540a2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70540a2a",
  null
  
)

export default component.exports